// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { itemsSearchParamsSchema } from '@/items/api/types';
import { ItemsListing } from '@/items/components/items-listing';
import { CATEGORY_TO_ITEM_TYPE } from '@/items/constants/item-types';
import { createFileRoute } from '@tanstack/react-router';

/**
 * Route configuration for the items index page.
 * Supports type filter via ?type=service|device|bulk query param.
 */
export const Route = createFileRoute('/_app/catalog/items/')({
  component: ItemsIndexRoute,
  validateSearch: itemsSearchParamsSchema,
});

function ItemsIndexRoute() {
  const searchParams = Route.useSearch();

  // Convert type query param to item type filter
  const itemType = searchParams.type
    ? CATEGORY_TO_ITEM_TYPE[searchParams.type]
    : 'all';
  const initialItemType = searchParams.newType
    ? CATEGORY_TO_ITEM_TYPE[searchParams.newType]
    : undefined;
  const initialItemName = searchParams.new
    ? decodeURIComponent(searchParams.new)
    : undefined;

  return (
    <ItemsListing
      itemType={itemType}
      searchParams={searchParams}
      initialItemName={initialItemName}
      initialItemType={initialItemType}
    />
  );
}
